<script>
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'vue-chartjs'

export default {
  	extends: Bar,

  	props: [
      'api',
      'year'
    ],

  	data: () => ({
	    chartdata: {
	      	datasets: [
		        {
		          backgroundColor: [],
		          data: []
		        }
	      	]
	    },
	    options: {
	    	responsive: true,
	      	maintainAspectRatio: false,
	      	layout: {
            	padding: {
            		top: 25
            	}
            },
	      	scales: {
	            xAxes: [{
	                type 	: 'category',
	                labels 	: ["Jan","Feb","Mac","Apr","Mei","Jun","Jul","Ogo","Sep","Okt","Nov","Dis"],
	                scaleLabel: {
	                	display: true,
	                	labelString: 'Bulan'
	                }
	            }],

	            yAxes: [{
	            	beginAtZero: true,
	            	scaleLabel: {
	                	display: true,
	                	labelString: 'RM'
	                },
	                ticks: {
	                	min: 0,
			           	callback: function(value, index, values) {
			            	return numeral(value).format('0,0')
			           	}
			        }
	            }]
	        },
	        legend: {
	        	display: false
	        },
	        plugins: {
	        	datalabels: {
	        		anchor: 'end',
	        		align: 'top',
	        		padding: {
	        			bottom: 5
	        		},
	        		font : {
	        			size: 10
	        		},
	        		formatter: function(value, context) {
						return 'RM ' + numeral(value).format('0,0.00');
					}
	        	}
	        }
	    }
  	}),

  	watch: {
  		year() {
  			this.get_data();
  		}
  	},

  	computed: {

  	},

  	mounted () {
  		let color_scheme = new ColorScheme;
  		let colors = color_scheme.from_hue(306).scheme('analogic').variation('light').colors(); 
  		for(let i=0; i<colors.length; i++) {
  			colors[i] = '#' + colors[i];
  		}
  		this.chartdata.datasets[0].backgroundColor = colors;

  		Chart.plugins.register(ChartDataLabels);
    	this.renderChart(this.chartdata, this.options);

    	//this.get_data();
  	},


  	methods: {


  		get_data() {

  			console.log('get_data');

  			let data = {'year': this.year};

  			axios
            	.post(this.api, data)
            	.then(response => {
                	let chart_data = response.data.data;
                	for(let i=0; i<chart_data.length; i++) {
                		chart_data[i] = parseFloat(chart_data[i]);
                	}
                	this.chartdata.datasets[0].data = chart_data;
                	this.renderChart(this.chartdata, this.options);
                });

  		}

  	}

        
}
</script>